import { apiClient } from '@/core/infra_api_client'
import type { InfraOperation } from '@/core/infra_types'

export interface FailedCleanupPreview {
  credentials: { id: string; name: string }[]
  environmentId: string
  environmentName: string
  hostId: string
  hostName?: string
  credentialId: string
  allowed: boolean
  blockers: string[]
  blockerCode?: string
  state: string
  account?: string
  resources: { kind: string; id: string; name: string }[]
  fingerprint?: string
  checkedAt: string
}

export interface FailedCleanupRequest {
  requestId: string
  credentialId: string
  fingerprint: string
  confirmation: string
}

export function inspectFailedCleanup(environmentId: string, credentialId: string) {
  return apiClient.get<FailedCleanupPreview>(
    `environments/${environmentId}/failed-provision-cleanup`,
    { credential_id: credentialId },
  )
}

export function submitFailedCleanup(environmentId: string, request: FailedCleanupRequest) {
  return apiClient.post<InfraOperation, FailedCleanupRequest>(
    `environments/${environmentId}/failed-provision-cleanup`, request,
  )
}
